module.exports = __webpack_public_path__ + "img/img-ad.c0e4e09d.png";